import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import spellsJson from 'assets/json/spell.json'
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { environment } from 'environments/environment';
interface eggGenerated {
  img: any,
  data: {
    tier: any,
    details: [
      mainElement: any,
      secondElement: any,
      mainElementImage: any,
      secondElementImage: any,
      speciality: any,
      specialityImage: any,
      gender: any,
      genderIcon: any
    ]
    spells: any
  }
  isLoading: boolean,
  loadingDone: boolean
}

declare const analytics

@Component({
  selector: 'app-f2p-new',
  templateUrl: './f2p-new.component.html',
  styleUrls: ['./f2p-new.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class F2pNewComponent implements OnInit {

  public eggsGenerated: any = []
  public stepProcess;
  public isSpinning
  public isSummoned
  public progressStep
  public selectedCarouselKmon
  public selectedSpellMain
  public selectedSpellSecond
  public selectedIndex
  // public account
  public intervalOne
  public intervalDue
  public intervalThree
  public intervalFour
  public canRedeemFree
  public isGenerating
  public isGeneratingError
  public isDoneAlready

  @ViewChild('scrollableOthers', { read: ElementRef }) public scrollableOthers: ElementRef<any>;
  wallet: string;

  constructor(
    private http: HttpClient,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private zone: NgZone,
    private userService: UserService,
    private web3Service: Web3Service
  ) {
    this.stepProcess = 0;
    this.isSpinning = false;
    this.isSummoned = false;
    this.progressStep = 0;
    this.selectedIndex = 0;
    this.isGenerating = false;
    this.isGeneratingError = false;
    let isDoneAlready = this.getCookieValue("onboarding")
    if (isDoneAlready == "done") {
      this.isDoneAlready = true;
    } else {
      this.isDoneAlready = false;
    }
    for (let i = 0; i < 4; i++) {
      let eggGenerated = {} as eggGenerated
      eggGenerated.img = "./assets/img/Icon/secret-egg.svg"
      eggGenerated.isLoading = false;
      eggGenerated.loadingDone = false;
      this.eggsGenerated.push(eggGenerated)
    }
    this.wallet = this.userService._userInfoData.recordedWallet;
    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((item: any) => {
    //     this.wallet = item[0];
    //     this.checkStartersAmount()
    //     //this.checkRedeemed()
    //   });
    // } else {
    //   this.wallet = this.appComponent.accounts[0];
    //   this.checkStartersAmount()
    //   //this.checkRedeemed()
    // }
    this.checkStartersAmount()
    //da rimuovere
    //this.getKryptomons() 
    console.log(this.eggsGenerated)
  }

  ngOnInit(): void {

  }

  swipeTest() {
    console.log('ahahhahahahahah')
  }

  async checkStartersAmount() {
    this.http.get(environment.apiBaseUrlV22 + "kryptomon-starters/wallet/" + this.wallet).subscribe((item: any) => {
      console.log(item)
      if (!item) {
        this.generateStarters()
      } else {
        if (item.starter_kryptomons_generated_count < 4) {
          this.generateStarters()
        } else {
          this.canRedeemFree = false;
        }
      }
    })
  }

  async generateStarters() {
    this.isGenerating = true;
    let timestamp = Date.now();
    var text = "Generate my starter Kryptomons: " + timestamp;
    var msg = await this.web3Service.getWeb3().utils.utf8ToHex(text)
    var from = this.wallet;
    var params = [msg, from]
    var method = 'personal_sign'
    console.log(from)
    this.web3Service.getWeb3().currentProvider.sendAsync({
      method,
      params,
      from,
    }, (err: any, result: any) => {
      console.log('fired')
      this.zone.run(() => {
        if (err || result.error) {
          console.log(err);
          console.log(result)
          //this.isLoading = false;
          //this.pickedStarter = this.pickedStarterBack
          this.isGeneratingError = true;
        } else {
          let post = {
            walletId: this.wallet,
            signatureHash: result.result,
            timestamp: timestamp,
          }

          console.log(post)

          this.http.post(environment.apiBaseUrl + "f2p/generateKryptomons_updated.php", post).subscribe((item: any) => {
            console.log(item)
            //this.isLoading = false;
            //clearInterval(intervalOne)
            if (item.response == "done") {
              this.isGenerating = false;
            } else {
              this.isGeneratingError = true;
            }
          })
        }
      })
    })
  }

  getKryptomons() {
    this.isSpinning = true;
    this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/kryptomons/detail?offset=0&limit=1000").subscribe((item: any) => {
      console.log(item)
      this.intervalOne = setInterval(() => {
        this.changeImage(0)
      }, 100)

      //let intervalArray = [intervalOne, intervalDue, intervalThree, intervalFour]
      let counter = 0;
      this.eggsGenerated[counter].isLoading = true;
      console.log(this.eggsGenerated[counter].isLoading)
      let interval = setInterval(() => {
        console.log(item[counter])
        console.log(counter)

        this.eggsGenerated[counter].tokenId = item[counter].tokenId
        this.eggsGenerated[counter].mainElement = item[counter].elementType
        this.eggsGenerated[counter].mainElementImage = "./assets/img/icons/" + item[counter].elementType.toLowerCase() + ".svg";
        this.eggsGenerated[counter].secondElement = item[counter].elementTypeSecond
        this.eggsGenerated[counter].secondElementImage = "./assets/img/icons/" + item[counter].elementTypeSecond.toLowerCase() + ".svg";
        if (item[counter].speciality == "Balanced") {
          item[counter].speciality = "Balance"
        }
        this.eggsGenerated[counter].speciality = item[counter].speciality
        if (item[counter].speciality == "Balance") {
          item[counter].specialityFixed = "Balanced"
        } else {
          item[counter].specialityFixed = item[counter].speciality;
        }
        this.eggsGenerated[counter].specialityImage = "./assets/img/Icon/" + item[counter].specialityFixed.toLowerCase() + "-icon.png"
        if (counter == 0) {
          clearInterval(this.intervalOne)
        } else if (counter == 1) {
          clearInterval(this.intervalDue)
        } else if (counter == 2) {
          clearInterval(this.intervalThree)
        } else {
          clearInterval(this.intervalFour)
        }
        this.eggsGenerated[counter].img = "./assets/img/" + item[counter].elementType + "/" + item[counter].speciality.toLowerCase() + ".png";
        if (item[counter].genes.sex < 5) {
          this.eggsGenerated[counter].gender = "female"
          this.eggsGenerated[counter].genderIcon = "./assets/img/Icon/female-icon.svg"
        } else {
          this.eggsGenerated[counter].gender = "male"
          this.eggsGenerated[counter].genderIcon = "./assets/img/Icon/male-icon.svg"
        }

        /*if(item[counter].ranking<650){
         this.eggsGenerated[counter].tierName = "Rookie"
         this.eggsGenerated[counter].tierNumber = 1
       }else if(item[counter].ranking>=650 && item[counter].ranking<700){
         this.eggsGenerated[counter].tierName = "Veteran"
         this.eggsGenerated[counter].tierNumber = 2
       }else{
         this.eggsGenerated[counter].tierName = "Elite"
         this.eggsGenerated[counter].tierNumber = 3
       }*/

        if (item[counter].ranking < 650) {
          this.eggsGenerated[counter].tierName = "Rookie"
          this.eggsGenerated[counter].tierNumber = 1
          if (this.eggsGenerated[counter].ranking < 625) {
            this.eggsGenerated[counter].starValue = 1
          } else {
            this.eggsGenerated[counter].starValue = 1.5
          }

        } else if (item[counter].ranking >= 650 && item[counter].ranking < 700) {
          this.eggsGenerated[counter].tierName = "Veteran"
          this.eggsGenerated[counter].tierNumber = 2
          if (item[counter].ranking >= 650 && item[counter].ranking < 675) {
            this.eggsGenerated[counter].starValue = 2
          } else {
            this.eggsGenerated[counter].starValue = 2.5
          }
        } else if (item[counter].ranking >= 700 && item[counter].ranking < 775) {
          this.eggsGenerated[counter].tierName = "Elite"
          this.eggsGenerated[counter].tierNumber = 3
          if (item[counter].ranking >= 700 && item[counter].ranking < 725) {
            this.eggsGenerated[counter].starValue = 3
          } else if (item[counter].ranking >= 725 && item[counter].ranking < 750) {
            this.eggsGenerated[counter].starValue = 3.5
          } else {
            this.eggsGenerated[counter].starValue = 4
          }
        } else {
          this.eggsGenerated[counter].tierName = "Hero"
          this.eggsGenerated[counter].tierNumber = 4
          if (item[counter].ranking >= 775 && item[counter].ranking < 800) {
            this.eggsGenerated[counter].starValue = 4.5
          } else {
            this.eggsGenerated[counter].starValue = 5
          }
        }

        this.eggsGenerated[counter].isLoading = false;
        this.eggsGenerated[counter].loadingDone = true;
        this.eggsGenerated[counter].kmonimg = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons/png/kmon_" + this.eggsGenerated[counter].tokenId + "_png.png";
        this.eggsGenerated[counter].hatched = false;

        this.eggsGenerated[counter].spellsMain = []
        this.eggsGenerated[counter].spellsSecond = []
        for (let i = 0; i < spellsJson.Spells.length; i++) {
          if (this.eggsGenerated[counter].mainElement.toLowerCase() == spellsJson.Spells[i].element) {
            this.eggsGenerated[counter].spellsMain.push(spellsJson.Spells[i]);
          } else if (this.eggsGenerated[counter].secondElement.toLowerCase() == spellsJson.Spells[i].element) {
            this.eggsGenerated[counter].spellsSecond.push(spellsJson.Spells[i]);
          }
        }

        counter++;
        if (counter > 3) {
          clearInterval(interval)
          this.isSpinning = false;
          this.isSummoned = true;
          console.log(this.eggsGenerated)
          console.log(spellsJson)
          analytics.track('Summoned Kryptomon', {
            section: 'onboarding-f2p'
          });


        } else {
          if (counter == 1) {
            this.intervalDue = setInterval(() => {
              this.changeImage(1)
            }, 100)

          } else if (counter == 2) {
            this.intervalThree = setInterval(() => {
              this.changeImage(2)
            }, 100)
          } else {
            this.intervalFour = setInterval(() => {
              this.changeImage(3)
            }, 100)
          }
          setTimeout(() => {
            let width = document.getElementById('otherKryptomon').offsetWidth + 20;
            this.scrollableOthers.nativeElement.scrollTo({ left: (this.scrollableOthers.nativeElement.scrollLeft + width), behavior: 'smooth' });
          }, 100)
          this.eggsGenerated[counter].isLoading = true;
          console.log(this.eggsGenerated[counter].isLoading)
        }
        console.log(this.selectedCarouselKmon)
      }, 10000)

    }, (err) => {
      console.log(err)
    })
  }


  selectMainSpell(sp) {
    this.selectedSpellMain = sp;
    analytics.track('Engaged Spells', {
      section: 'onboarding-f2p',
      value: sp.name
    });
  }
  selectSecondSpell(sp) {
    this.selectedSpellSecond = sp;
    analytics.track('Engaged Spells', {
      section: 'onboarding-f2p',
      value: sp.name
    });
  }


  navigateLeft() {
    if (this.selectedIndex > 0) {
      this.selectedIndex = this.selectedIndex - 1;
      this.selectedCarouselKmon = this.eggsGenerated[this.selectedIndex]
      this.selectedSpellMain = this.eggsGenerated[this.selectedIndex].spellsMain[0]
      this.selectedSpellSecond = this.eggsGenerated[this.selectedIndex].spellsSecond[0]
    } else {
      this.selectedIndex = 3;
      this.selectedCarouselKmon = this.eggsGenerated[this.selectedIndex]
      this.selectedSpellMain = this.eggsGenerated[this.selectedIndex].spellsMain[0]
      this.selectedSpellSecond = this.eggsGenerated[this.selectedIndex].spellsSecond[0]
    }
    console.log(this.selectedCarouselKmon)
  }
  navigateRight() {
    if (this.selectedIndex < this.eggsGenerated.length - 1) {
      this.selectedIndex = this.selectedIndex + 1;
      this.selectedCarouselKmon = this.eggsGenerated[this.selectedIndex]
      this.selectedSpellMain = this.eggsGenerated[this.selectedIndex].spellsMain[0]
      this.selectedSpellSecond = this.eggsGenerated[this.selectedIndex].spellsSecond[0]
    } else {
      this.selectedIndex = 0;
      this.selectedCarouselKmon = this.eggsGenerated[this.selectedIndex]
      this.selectedSpellMain = this.eggsGenerated[this.selectedIndex].spellsMain[0]
      this.selectedSpellSecond = this.eggsGenerated[this.selectedIndex].spellsSecond[0]
    }
    console.log(this.selectedCarouselKmon)
  }

  changeImage(index) {
    //console.log(index)
    let spec = ["attack", "balance", "defense", "super"]
    let element = ["Fire", "Ghost", "Air", "Ground", "Water", "Ice", "Electro", "Grass"]
    let rand = Math.floor(Math.random() * (3 - 0 + 1) + 0)
    let randEle = Math.floor(Math.random() * (7 - 0 + 1) + 0)
    this.eggsGenerated[index].img = "./assets/img/" + element[randEle] + "/" + spec[rand] + ".png"
  }


  triggerHatch() {
    this.stepProcess = 1;
    this.selectedCarouselKmon = this.eggsGenerated[0]
    this.selectedSpellMain = this.eggsGenerated[0].spellsMain[0]
    this.selectedSpellSecond = this.eggsGenerated[0].spellsSecond[0]
    var interval = setInterval(() => {
      if (this.progressStep < 40) {
        this.progressStep = this.progressStep + 0.6; //6 secs
      } else if (this.progressStep > 40 && this.progressStep < 90) {
        this.progressStep = this.progressStep + 0.2; //16secs
      } else {
        this.progressStep = this.progressStep + 0.03; //20secs
      }

      if (this.progressStep > 24 && this.progressStep < 26) {
        this.eggsGenerated[0].hatched = true
        setTimeout(() => {
          this.selectedCarouselKmon = this.eggsGenerated[1]
          this.selectedSpellMain = this.eggsGenerated[1].spellsMain[0]
          this.selectedSpellSecond = this.eggsGenerated[1].spellsSecond[0]
        }, 3000)
      } else if (this.progressStep > 49 && this.progressStep < 51) {
        this.eggsGenerated[1].hatched = true
        setTimeout(() => {
          this.selectedCarouselKmon = this.eggsGenerated[2]
          this.selectedSpellMain = this.eggsGenerated[2].spellsMain[0]
          this.selectedSpellSecond = this.eggsGenerated[2].spellsSecond[0]
        }, 3000)
      } else if (this.progressStep > 74 && this.progressStep < 76) {
        this.eggsGenerated[2].hatched = true
        setTimeout(() => {
          this.selectedCarouselKmon = this.eggsGenerated[3]
          this.selectedSpellMain = this.eggsGenerated[3].spellsMain[0]
          this.selectedSpellSecond = this.eggsGenerated[3].spellsSecond[0]
        }, 3000)
      } else if (this.progressStep > 99 && this.progressStep < 101) {
        this.eggsGenerated[3].hatched = true
      }

      if (this.progressStep > 99) {
        this.progressStep = 100;
        //this.selectedCarouselKmon = this.eggsGenerated[0];
        clearInterval(interval)
        this.stepProcess = 2;
        analytics.track('Hatched Kryptomon', {
          section: 'onboarding-f2p'
        });
      }
    }, 100)

  }

  openGame() {
    this.setCookie("onboarding", "done", 1000)

    if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
      console.log(this.deviceService.getDeviceInfo())
      if (this.deviceService.getDeviceInfo().os == 'iOS') {
        analytics.track('Started Playing', {
          section: 'onboarding-f2p',
          value: 'ios'
        });
        window.open("https://testflight.apple.com/join/CkBY8AAq", '_blank').focus();

      } else {
        window.open("https://play.google.com/store/apps/details?id=com.KryptomonCompany.Kryptomon&pli=1", '_blank').focus();
        analytics.track('Started Playing', {
          section: 'onboarding-f2p',
          value: 'android'
        });

      }
    } else {
      analytics.track('Started Playing', {
        section: 'onboarding-f2p',
        value: 'desktop'
      });
      this.router.navigate(["/play"])

    }
  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    console.log('cookie-set')

  }

  getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  }


}
